import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataService } from '@app-core/services/data/data.service';
import { LoginTypes } from '@app-core/services/google-tag-manager/google-tag-manager.service';
import { getClientConfig } from '@config/client-config';
import { IframeAuthService } from '../../services/iframe-auth/iframe-auth.service';

interface ImplicitLoginParams {
  access_token: string;
  redirect_path?: string;
  deviceId?: string;
  region?: string;
}

@Component({
  selector: 'app-iframe-implicit-login',
  templateUrl: './iframe-implicit-login.component.html',
  styleUrls: ['./iframe-implicit-login.component.scss'],
})
export class IframeImplicitLoginComponent implements OnInit {
  public clientConfig = getClientConfig().configuration;
  constructor(private route: ActivatedRoute, private dataService: DataService, private iframeAuthService: IframeAuthService) {}

  public ngOnInit() {
    this.listenParams();
  }

  private listenParams() {
    this.route.queryParams.subscribe((params: ImplicitLoginParams) => this.validateSSOAccessToken(params));
  }

  private validateSSOAccessToken(params: ImplicitLoginParams) {
    const { access_token: ssoAccessToken, redirect_path = 'home', deviceId, region } = params;
    if (ssoAccessToken) {
      this.iframeAuthService.authenticateSSOUser(this.clientConfig.clientName, ssoAccessToken, deviceId, region).subscribe(
        (res) => {
          const loginInfo = { ...res, loginType: 'fleetmanager' };
          this.dataService.userLogin.next({ loginInfo, redirectUrl: redirect_path, loginType: LoginTypes.sso });
        },
        () => {
          this.iframeAuthService.navigateToUnauthorizedErrorPage();
        }
      );
    } else if (this.iframeAuthService.isUserAuthenticated()) {
      this.iframeAuthService.redirectLoggedInUser();
    } else {
      this.iframeAuthService.navigateToUnauthorizedErrorPage();
    }
  }
}
